import { useMediaQuery } from '@mantine/hooks'

import { size } from 'src/Helpers/constants.ts'

export const useResponsive = (): { isTablet: undefined | boolean } => {
  const isTablet = useMediaQuery(`(max-width: ${size.tablet})`)

  return {
    isTablet,
  }
}
